import { useEffect, useMemo, useState } from "react";
import { DatePickerProps } from "../components/date-picker/DatePicker";
import useHandleMonthChange from "./useHandleMonthChange";
import getCalendarDates from "../utils/getCalendarDates";
import months from "../utils/monthsList";
import getMonthName from "../utils/getMonthName";
import getDaysOfWeek from "../utils/getDaysOfWeek";

function useDateLogic({
  preSelectedDate,
  weekStartsOn,
  customDaysOfWeek,
  onChange,
}: DatePickerProps) {
  const [currentDate, setCurrentDate] = useState(new Date());
  const [selectedDate, setSelectedDate] = useState<Date | null>(null);

  const monthsRange = useMemo(() => {
    return `${getMonthName(months, currentDate.getMonth())}`;
  }, [currentDate]);

  useEffect(() => {
    if (preSelectedDate) {
      setSelectedDate(preSelectedDate);
    }
  }, [preSelectedDate]);

  const daysOfWeek = getDaysOfWeek(weekStartsOn, customDaysOfWeek);

  const handleDateChange = (date: Date) => {
    setSelectedDate(date);
    onChange(date);
  };

  const { handleMonthChange, handleNextMonth, handlePreviousMonth } =
    useHandleMonthChange({ setCurrentDate });

  const dates = getCalendarDates(currentDate.getMonth(), currentDate.getFullYear(), weekStartsOn)

  return {
    currentDate,
    setCurrentDate,
    selectedDate,
    monthsRange,
    daysOfWeek,
    handleMonthChange,
    handleNextMonth,
    handleDateChange,
    handlePreviousMonth,
    dates,
  };
}

export default useDateLogic;
